import {dispatch} from 'od-modules/secure_store/store';
import {SET_MEMBERSHIP_SUBSCRIPTION_OFFER} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')('membership-subscription-details');
    },
    getMethod() {
        return 'GET';
    },
    requestSuccess(data) {
        Odigeo.trigger('membershipSubscriptionDetailsOk', data);
        if (data !== null && dispatch && Odigeo.Utils.getCurrentPath().indexOf('/secure') !== -1) {
            dispatch({type: SET_MEMBERSHIP_SUBSCRIPTION_OFFER, entry: data});
        }
        return data;
    },
    requestError(error) {
        Odigeo.trigger('membershipSubscriptionDetailsFail', error);
    },
};
